import type { ComparisonFilterExpression } from '@@/packages/shared/libs/search/types';
import type { Discussion } from '@@/packages/shared/types/models/discussion';

const discussionCommentsHaveEvidence = (discussion: Discussion) =>
  !!discussion?.comments?.find((comment) => comment?.attachments?.length > 0);

export const discussionMatchesOperand = (
  discussion: Discussion,
  operand: ComparisonFilterExpression,
) => {
  switch (operand.field) {
    case 'archived':
      // If filtering for archived return items that have `archivedAt` property
      // else return items that don't have an `archivedAt` property
      return operand.value ? discussion.archivedAt != null : discussion.archivedAt == null;
    case 'hasEvidence':
      return operand.value
        ? discussionCommentsHaveEvidence(discussion)
        : !discussionCommentsHaveEvidence(discussion);
    case 'associatedType':
      return operand.comparator === 'is_any'
        ? (operand.value as string).indexOf(discussion.associatedType) > -1
        : !((operand.value as string).indexOf(discussion.associatedType) > -1);
    default:
      return false;
  }
};
